import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";

const GET_LOAN_APPLICATIONS_QUERY = gql`
  query GetLoanApplications {
    loanApplications {
      id
      requestedLoanAmount
      requestedPaybackTimeMonths
      applyingCompany {
        customerCompany {
          name
          organisationNumber
          id
        }
      }
    }
  }
`;

export interface IGetLoanApplicationsResponse {
  loanApplications: {
    id: string;
    requestedLoanAmount: number;
    requestedPaybackTimeMonths: number;
    applyingCompany: {
      customerCompany: {
        name: string;
        organisationNumber: string;
        id: string;
      };
    };
  }[];
}

export const getLoanApplications = async () => {
  return await client.request<IGetLoanApplicationsResponse>(
    GET_LOAN_APPLICATIONS_QUERY,
  );
};
